module.exports = __webpack_public_path__ + "img/bg_img01.06003059.png";